module.exports = {"610104001":"青年路街道","610104002":"北院门街道","610104003":"北关街道","610104004":"红庙坡街道","610104005":"环城西路街道","610104006":"西关街道","610104007":"土门街道","610104008":"桃园路街道","610104009":"枣园街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610104.json
// module id = 2571
// module chunks = 0